import React from "react";
import DashboardScreen from "../Containers/Dashboard/DashboardScreen";

export const DashboardRoute = (): React.JSX.Element => <DashboardScreen />

